module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "cht",
    attrs: {
      "id": "ch_1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Text/contents#ch1"
    }
  }, [_c('b', [_vm._v("Virgin Mary, Put Putin")]), _vm._v(" Away "), _c('b', [_vm._v("(Punk Prayer)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("(Chorus)"), _c('br'), _vm._v("\n  Virgin Mary, Mother of God, put Putin away"), _c('br'), _vm._v("\n  Put Putin away, put Putin away!"), _c('br'), _vm._v("\n  (End chorus)")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Black robe, golden epaulettes"), _c('br'), _vm._v("\n  All parishioners crawl to bow"), _c('br'), _vm._v("\n  The phantom of liberty is in heaven"), _c('br'), _vm._v("\n  Gay pride sent to Siberia in chains")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The head of the KGB, their chief saint,"), _c('br'), _vm._v("\n  Leads protesters to prison under escort"), _c('br'), _vm._v("\n  In order not to offend His Holiness"), _c('br'), _vm._v("\n  Women must give birth and love")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Shit, shit, the Lord’s shit!"), _c('br'), _vm._v("\n  Shit, shit, the Lord’s shit!")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("(Chorus)"), _c('br'), _vm._v("\n  Virgin Mary, Mother of God, become a feminist"), _c('br'), _vm._v("\n  Become a feminist, become a feminist!"), _c('br'), _vm._v("\n  (End chorus)")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The church’s praise of rotten dictators"), _c('br'), _vm._v("\n  The cross-bearer procession of black limousines"), _c('br'), _vm._v("\n  A teacher-preacher will meet you at school"), _c('br'), _vm._v("\n  Go to class—bring him money!")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Patriarch Gundyaev believes in Putin"), _c('br'), _vm._v("\n  Bitch, better believe in God instead!"), _c('br'), _vm._v("\n  The belt of the Virgin can’t replace mass meetings"), _c('br'), _vm._v("\n  Mary, Mother of God, is with us in protest!")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("(Chorus)"), _c('br'), _vm._v("\n  Virgin Mary, Mother of God, put Putin away"), _c('br'), _vm._v("\n  Put Putin away, put Putin away!"), _c('br'), _vm._v("\n  (End chorus)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e695b40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Chapter1.vue
// module id = 69
// module chunks = 0